import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  remove,
  update,
  add,
} from '../../../../../redux/category-type/actions';
import { loading } from '../../../../../redux/category-type/selectors';
import CategoryTypeModal from './CategoryTypeModal';

const selector = createStructuredSelector({
  loading,
});

const actions = {
  add,
  update,
  remove,
};

export default connect(selector, actions)(CategoryTypeModal);
